import type { createApp } from 'vue';
import type { FlowEvents } from '@/shared/composables';
import { captureMessage } from '@sentry/vue';
import mitt from 'mitt';
import { newFlowPages, NewInsuranceSteps } from '@/app/flow';
import { MAIN_PRODUCT, PRODUCTS, RENEW_PRODUCT } from './app.constants';
import i18n from './plugins/i18n';
import { flowOrderMap, getPathHead, getProductNames } from './router';

type App = ReturnType<typeof createApp>;

function getLandingPageUrl(locale: string): string {
  const domain = window.location.origin;
  return `${domain}/${locale}/${MAIN_PRODUCT}`;
}

function getRenewalLandingUrl(locale: string): string {
  const domain = window.location.origin;
  return `${domain}/${locale}/${RENEW_PRODUCT}`;
}

export default {
  install: (app: App) => {
    const locale = i18n.global.locale.value;
    app.provide('locale', locale);

    const landingUrl = getLandingPageUrl(locale);
    app.provide('landingUrl', landingUrl);
    const renewLandingUrl = getRenewalLandingUrl(locale);
    app.provide('renewLandingUrl', renewLandingUrl);

    const eventEmitter = mitt<FlowEvents>();
    app.provide('eventEmitter', eventEmitter);

    app.provide('flowOrderMap', flowOrderMap);

    // provide other global services here
    app.provide('onFlowInit', () => {
      const { mainProduct, productName } = getProductNames();
      const pathHead = getPathHead(mainProduct, productName);
      app.provide('productName', productName);
      app.provide('pathHead', pathHead);
      app.provide('isRenew', productName === PRODUCTS.RENEWAL);
      app.provide('newFlowPages', newFlowPages);
      app.provide('NewInsuranceSteps', NewInsuranceSteps);
    });

    // this is used by the loyalty-components lib to send errors to sentry correctly
    app.provide('captureMessage', captureMessage);
  },
};
